export default (elems = []) => {
  let height = 0;
  elems.forEach((elem) => {
    height += elem.offsetHeight;
  });
  return height;
};
